export default {
  duplicateCandidateSelector: {
    title: 'Kandidat für Stammdatenübernahme wählen',
    description:
      'Es wurden mehrere passende Kandidaten gefunden. Bitte wählen Sie den Kandidaten aus, dessen Daten aktualisiert werden sollen.',
    cancel: 'Abbrechen'
  },
  lienertApplicantDetails: {
    actions: {
      backButton: 'Zurück',
      toCandidateButton: 'Zum Kandidaten',
      applyDataToCandidateButton: 'Stammdaten & Suchprofil übernehmen',
      toLinkedIn: 'Zum LinkedIn-Profil'
    },
    error: {
      loadingError: 'Fehler beim Laden des Kandidatenprofils',
      noData: 'Keine Daten gefunden',
      transferFailed: 'Fehler beim Übertragen der Stammdaten.',
      noMatchingCandidate: 'Kein passender Kandidat gefunden.',
      invalidPostalCode: 'Die eingegebene Postleitzahl existiert nicht im Land des Kandidaten.'
    },
    success: {
      transferSuccess: 'Stammdaten & Suchprofil wurden erfolgreich übernommen.'
    },
    title: {
      headerData: 'Persönliche Informationen',
      headerMatchingProfile: 'Matching Profil',
      salutation: 'Anrede',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phoneNumber: 'Telefonnummer',
      street: 'Straße',
      birthDate: 'Geburtsdatum',
      location: 'Niederlassung',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      linkedIn: 'LinkedIn'
    },
    documentTypes: {
      cv: 'Lebenslauf',
      reference: 'Arbeitszeugnisse',
      diploma: 'Diplome',
      unknown: 'Dokumente'
    }
  },
  searchField: {
    placeHolder: 'Kandidaten Bewerberportal suche'
  },
  deleteCandidateProfileDialog: {
    title: 'Kandidatenprofil löschen',
    description: 'Möchten Sie das Profil von ',
    descriptionEnd: ' wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    success: 'Kandidatenprofil wurde erfolgreich gelöscht',
    error: 'Kandidatenprofil konnte nicht gelöscht werden'
  },
  tableTitle: 'Kandidatenprofile',
  tableCellHeader: {
    location: 'Standort',
    createdAt: 'Registriert am',
    title: 'Anrede',
    salutation: 'Anrede',
    mailAddress: 'E-Mail Adresse',
    currentJob: 'Aktuelle Position',
    firstName: 'Vorname',
    lastName: 'Nachname',
    mail: 'E-Mail',
    phoneNumber: 'Telefonnummer',
    birthDate: 'Geburtsdatum',
    street: 'Straße',
    postalCode: 'Postleitzahl',
    city: 'Stadt',
    currentCompany: 'Aktuelles Unternehmen',
    lastChange: 'Letzte Änderung',
    pastContact: 'Letzter Kontakt'
  }
};
